import { Box, Button, Typography } from '@alice-financial/pretext-ui'
import React from 'react'
import { FormattedMessage } from 'react-intl'

type EmailSentConfirmationProps = {
  expiresInMinutes: number
  onReset: () => void
}

/**
 * Pure component for displaying email sent confirmation
 * Shows expiration time and allows user to request a new code
 */
export const EmailSentConfirmation: React.FC<EmailSentConfirmationProps> = ({
  expiresInMinutes,
  onReset,
}) => {
  return (
    <Box mb={3}>
      <Typography variant="body2" gutterBottom>
        <FormattedMessage id="auth.login.email_sent_with_expiration" values={{ minutes: expiresInMinutes }} />
      </Typography>
      <Button variant="outlined" onClick={onReset}>
        <FormattedMessage id="auth.login.get_new_link" />
      </Button>
    </Box>
  )
}
